import React from 'react'
import { Trans } from 'react-i18next'
import { FaqAccordion } from './FaqAccordion'

export const FaqSection = () => {
    return (
        <section className='!py-8 sm:!py-10 lg:!py-[60px]'>
            <h2 className='section-heading text-center mb-6 sm:mb-8 lg:mb-11'>
                <Trans
                    i18nKey="faq.heading"
                    ns="home"
                    components={{ br1: <br className='sm:hidden' /> }}
                />
            </h2>

            <div className='max-w-[542px] md:max-w-full lg:max-w-[920px] mx-auto px-5 sm:px-6 lg:px-10'>
                <FaqAccordion />
            </div>
        </section>
    )
}
